import { StyleSheet } from '@react-pdf/renderer';

export default StyleSheet.create({
    page: {
        fontFamily: 'Open Sans',
        fontSize: 10,
        padding: 20,
        lineHeight: 1.5
    },

    heading: {
        fontSize: 12,
        marginTop: 20,
        marginBottom: 10,
        textDecoration: 'underline'
    },

    subHeading: {
        fontSize: 10,
        marginTop: 5,
        marginBottom: 5,
    },

    dataView: {
        flexDirection: 'row',
    },
    dataHead: {
        flex: 1,
        padding: 4,
        borderRight: '1 solid #ccc',
        borderBottom: '1 solid #ccc',
        borderLeft: '1 solid #ccc',
    },
    dataPara: {
        flex: 1,
        padding: 4,
        borderRight: '1 solid #ccc',
        borderBottom: '1 solid #ccc',
    },

    tableHeader: {
        flexDirection: 'row',
        borderBottom: '1 solid black',
        borderTop: '1 solid #ccc',
        borderRight: '1 solid #ccc',
    },
    tableRow: {
        flexDirection: 'row',
        borderBottom: '1 solid #ccc',
        borderRight: '1 solid #ccc',
    },
    column: {
        flex: 1,
        padding: 4,
        borderLeft: '1 solid #ccc',
    },
    column2: {
        flex: 2,
        padding: 4,
        borderLeft: '1 solid #ccc',
    },
    column3: {
        flex: 3,
        padding: 4,
        borderLeft: '1 solid #ccc',
    },
    column9: {
        flex: 9,
        padding: 4,
        borderLeft: '1 solid #ccc',
    }
});